export enum ProjectTimeDisplayMode {
  timeline = 'timeline',
  list = 'list',
}
